import { AES, enc } from 'crypto-js';
import { SECRET } from '../constants/Secret';

export function decodeSafedata(data: string | null) {
  let bytes;
  try {
    bytes = AES.decrypt(data, SECRET);
    const decrypted = bytes.toString(enc.Utf8);
    return decrypted;
  } catch (err) {
    console.log('UNABLE TO DECIPHER', err);
  }
}
